<div fxLayout="column">
  <mat-chip-grid #icdCodeChipGrid fxFlex>
    <mat-chip
      *ngFor="let code of value; index as i"
      [value]="code"
      selectable
      removable
      (removed)="removeSelectedCode(code)"
      fxLayoutAlign="space-between center"
    >
      <!-- TODO: display actual code name -->
      {{ code }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <input
      matInput
      fxFlex
      #selectCptInput
      placholder="G33, G33.12"
      [formControl]="icdCodeControl"
      [matChipInputFor]="icdCodeChipGrid"
      [matChipInputAddOnBlur]="true"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="addCode($event)"
      id="input-chip-list"
    />
    <!-- TODO: Implement autocomplete -->
    <!-- <input
      matInput
      fxFlex
      #selectCptInput
      [formControl]="icdCodeControl"
      [matAutocomplete]="codesAutocomplete"
      [matChipInputFor]="cptChipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      id="input-chip-list"
    /> -->
  </mat-chip-grid>
  <!-- <mat-autocomplete
    fxFlex
    #codesAutocomplete="matAutocomplete"
    (optionSelected)="selected($event)"
    panelWidth="550px"
  >
    <mat-option
      *ngFor="let product of filteredCodes | async"
      [value]="product"
    >
      <span *ngIf="product.sku">[{{ product.sku }}]</span>
      <span *ngIf="!product.sku && !!product.getCPTCodes">[{{ product.getCPTCodes() | join }}]</span>
      {{ getItemLabel(product) }}
    </mat-option>
  </mat-autocomplete> -->

  <div
    *ngIf="value && value.length > 1 && !noCopyPaste"
    class="mt-4"
    fxLayout="row"
    fxLayoutAlign="start end"
  >
    <button
      mat-flat-button
      type="button"
      class="btn-sm"
      (click)="removeAllCodes()"
    >
      {{ 'common.remove-all' | translate }}
    </button>
    <button
      mat-flat-button
      type="button"
      class="btn-sm"
      (click)="copySelectedValue()"
    >
      {{ 'common.copy' | translate }}
    </button>
  </div>
</div>
  